var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-gr",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0d5eaf",
    fillRule: "evenodd",
    d: "M0 0h640v53.3H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 53.3h640v53.4H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d5eaf",
    fillRule: "evenodd",
    d: "M0 106.7h640V160H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 160h640v53.3H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d5eaf",
    d: "M0 0h266.7v266.7H0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d5eaf",
    fillRule: "evenodd",
    d: "M0 213.3h640v53.4H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 266.7h640V320H0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d5eaf",
    fillRule: "evenodd",
    d: "M0 320h640v53.3H0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 373.3h640v53.4H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.7 0H160v266.7h-53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 106.7h266.7V160H0z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d5eaf",
    d: "M0 426.7h640V480H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/gr.969458b727378ff7b215343cfc6c9165.svg";
export { ForwardRef as ReactComponent };